import { render, staticRenderFns } from "./newSale.vue?vue&type=template&id=7f5d4116&scoped=true&"
import script from "./newSale.vue?vue&type=script&lang=js&"
export * from "./newSale.vue?vue&type=script&lang=js&"
import style0 from "./newSale.vue?vue&type=style&index=0&id=7f5d4116&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5d4116",
  null
  
)

export default component.exports